import { Braintree_transaction } from '../banking/braintree_transaction';
import { Store_order_item } from './store_order_item';

export class Store_order {
	
	id: string;
	horse_show_id: string;
	processor_transaction_id: string;
	system_transaction_id: string;
	amount: number;
	additional_field_values: string;
	order_date: Date;
	ip_address: string;
	category_number: number;
	order_items: Store_order_item[] = [];
	transaction: Braintree_transaction;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}
	
}